import React from 'react';
import '../../components/css/popupstyle.css';
import DashboardHeaderIcons from '../dashboardHeaderIcons';
import $ from 'jquery';
import { userService } from '../../_services/user.service';

class ReportPopup extends React.Component {

    constructor(props) {
        super(props);
        this.reportData = this.reportData.bind(this);
        if (localStorage.getItem('user') == null || localStorage.getItem('user') == "" || localStorage.getItem('user') == "{}") {
            userService.logout();
        }
        try {
            this.state = {
                paramsName: JSON.parse(localStorage.getItem('user')).paramsname,
                MonthList: [],
                loader: false,
                error: ''
            };
        }
        catch (error) { }
    }
    componentDidMount() {
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
        this.GetCommission_Separate('admin', '');
    }
    GetCommission_Separate(whname, mname) {
        this.setState({ loader: true });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify({ whname, mname })
        };
        return fetch(`/api/ws/wh_commission_type`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    if (apidata.length > 0) {
                        this.setState({ MonthList: apidata[0]["monthList"], loader: false, error: '' });
                    } else {
                        this.setState({ loader: false, error: 'Data not found' });
                    }
                }
                catch (error) {
                }
            });
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    reportData(e) {
        
        try {
            let Origin_Location = window.location.protocol + "//" + window.location.host;
            let month_year = $("#commissionSelect").val();
            let paramsName = this.state.paramsName;
            window.open(
                Origin_Location + '/report/admincommreport_New?&name=' + paramsName + '&csvfor=admin&m=' + month_year + '&processor=0',
                '_blank' 
            );
            e.preventDefault();
        }
        catch (error) {}
    }


    render() {
        const { loader, error } = this.state;
        return (
            <div className='popup mfp-zoom-in report-section commission-edit popup-right-radius'>
                <div className='popup_inner'>

                    <h1>{this.props.text}<button onClick={this.props.closePopup}>X</button></h1>
                    {
                        loader ? <div className="theme-loader commissionLoader"></div> : null
                    }
                    <div id="dashboard_header" className="big_dash_header">
                        <div className="dashboard-icons">

                            <DashboardHeaderIcons />

                        </div>
                        <div id="dashboard_header_inner">
                            <div id="dashboard-back-button"></div>
                            <div id="dashboard_header_select" className="admin-commission">
                                <form>
                                    {/*<div className="firstDatePicker">

                                        <label>Month</label>

                                        <select id="month">
                                            <option>January</option>
                                            <option>February</option>
                                            <option>March</option>
                                            <option>April</option>
                                            <option>May</option>
                                            <option>June</option>
                                            <option>July</option>
                                            <option>August</option>
                                            <option>September</option>
                                            <option>October</option>
                                            <option>November</option>
                                            <option>December</option>
                                        </select>

                                    </div>
                                    <div className="secondDatePicker">

                                        <label>Year</label>

                                        <select id="year">
                                            <option>2015</option>
                                            <option>2016</option>
                                            <option>2017</option>
                                            <option>2018</option>
                                            <option>2019</option>
                                            <option>2020</option>
                                            <option>2021</option>
                                            <option>2022</option>
                                        </select>

                                    </div>*/}
                                    <div className="selectSection payout">
                                        <label>Select Month, Year</label>
                                        <span className="down-arrow"></span>
                                        <select className="form-Control" id="commissionSelect" onChange={this.handleOnChange} value={this.state.value} >
                                            {
                                                this.state.MonthList != null ?
                                                    this.state.MonthList.map((obj, index) => {
                                                        return <option value={obj.monthYearname}>{obj.monthYearname.replace(',', ', ')}</option>
                                                    }) : null
                                            }
                                        </select>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="pop-btn ungap">
                                        <button className="btn" onClick={this.reportData}>Download</button>
                                        <button className="btn cancel" onClick={this.props.closePopup}>Cancel</button>
                                    </div>

                                </form>

                            </div>
                        </div>
                    </div>


                </div>
            </div>
        );
    }
}


export default ReportPopup;